import React from 'react'
import { NavbarSupportSystem } from "../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { Footer } from "../../components/share/Footer";
import { SupportResultReportComponent } from '../../components/SupportSystem/SupportResultReportComponent'
export const SupportResultReportContainer = () => {
    const title = "รายงานประจําปีงบประมาณ"
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={title}></HeadTitle>
            <SupportResultReportComponent />
            <Footer />
        </div>
    );
}


export function TableLandingSupportContainer() {

}

